export class UserDataModel {
  id: number = 0;
  nome: string = "";
  nomeCurto: string = "";
  login: string = "";
  email: string = "";
  cpf: string = "";
  quandoAceitouTermoCiencia?: string = "";
  grupos: GrupoModel[] = [];
  permissoesEscolaAnoPorGrupo: PermissoesEscolaAnoPorGrupoUsuario[] = [];
}

export class ContractDataModel {
  anoInicial: number = 0;
  linkLogoContrato: string = "";
  termoCienciaConsentimento: string = "";
  endPoint: string = "";
  escrituracao: number | null = null;
}

export class PessoalDataModel {
  id: number = 0;
  identificacao: string = "";
  email: string = "";
  urlFotoPerfil: string = "";
}

export class AlunoModel {
  carteirinha!: CarteirinhaModel;
}

export class CarteirinhaModel {
  codigoAluno: number = 0;
  nome: string = "";
  codigoEscola: number = 0;
  escola: string = "";
  codigoTurma: number = 0;
  turma: string = "";
  cpf: string = "";
  dataNascimento: Date = new Date();
  matricula: string = "";
  urlFoto: string = "";
}

export class ResponsavelModel {
  codigoResponsavelTabelaResponsavel: number = 0;
  codigoResponsavel: number = 0;
  estudantes: EstudantesModel[] = [];
}

export class EstudantesModel {
  codigoAluno: number = 0;
  nome: string = "";
  codigoEscola: number = 0;
  escola: string = "";
  codigoTurma: number = 0;
  turma: string = "";
  dataNascimento: Date = new Date();
  matricula: string = "";
  urlFoto: string = "";
}

export class GrupoModel {
  id: number = 0;
  descGrupo: string = "";
  aluno: boolean = false;
  responsavel: boolean = false;
  professor: boolean = false;
  permissoes: PermissoesModel[] = [];
  escolas: EscolasModel[] = [];

  constructor(nome: string, id: number) {
    this.descGrupo = nome
    this.id = id
  }
}

export class PermissoesEscolaAnoPorGrupoUsuario {
  codigoGrupo: number = 0;
  ano: number = 0;
  codigoEscola: number = 0;

  constructor(codigoGrupo: number, ano: number, codigoEscola: number) {
    this.codigoGrupo = codigoGrupo
    this.ano = ano
    this.codigoEscola = codigoEscola
  }
}

export class ModuloSistemaModel {
  id: number = 0;
  nome: string = "";

  constructor(nome: string, id: number) {
    this.nome = nome
    this.id = id
  }
}

export class PermissoesModel {
  segMenuId: number = 0;
  descricao: string = "";
  segServicoId: number = 0;
  modulo: string = "";
  url: string = "";
  icone: string = "";
  menu: boolean = false;
  subMenu: boolean = false;
  segMenuPaiId: number = 0;
  x: number = 0;
  y: number = 0;
  contratoEspecifico: boolean = false;
  menuDinamico: string = "";
  somentePermissao: boolean = false;
  sistemaLegado: boolean = false;
  rota: string = "";
  path: string = "";
  name: string = "";
  visualizar: boolean = false;
  incluir: boolean = false;
  alterar: boolean = false;
  excluir: boolean = false;
}

export class PermissaoAcaoTelaModel {
  visualizar: boolean = false;
  incluir: boolean = false;
  alterar: boolean = false;
  excluir: boolean = false;

  constructor(visualizar: boolean, incluir: boolean, alterar: boolean, excluir: boolean) {
    this.visualizar = visualizar;
    this.incluir = incluir;
    this.alterar = alterar;
    this.excluir = excluir;
  }
}

export class EscolasModel {
  id: number = 0;
  nome: string = "";
  codigoINEP: number = 0;
  dataInicioAnoLetivo: Date = new Date();
  dataTerminoAnoLetivo: Date = new Date();
  codigoPessoalDiretor: number = 0;
  usaTotalFaltasNoDiario: boolean = false;
  usaDiarioEletronico: boolean = false;
  usaCargaHorariaConteudoLecionado: boolean = false;
  usaModuloAulaConteudoLecionadoRegente: boolean = false;
  usaCamposRecursoHabilidadeConteudoLecionado: boolean = false;
  labelConteudoLecionado: string = "";
  labelConteudoMenu: string = "";
  labelCampoRecursoConteudoLecionado: string = "";
  labelCampoHabilidadeConteudoLecionado: string = "";
  labelAtividadesComplementaresProfessor: string = "";
  labelCampoConteudoPrevisto: string = "";
  diarioModoLancamento: number = 1;
  endereco: string = "";
  numero: string = "";
  complemento: string = "";
  cep: string = "";
  uf: string = "";
  email: string = "";
  ddd: string = "";
  telefone: string = "";
  telefonePublico1: string = "";
  parametros: string = "";

  constructor(nome: string, id: number) {
    this.nome = nome;
    this.id = id;
  }
}

export class AnoModel {
  id: number = 0;
  nome: string = "";

  constructor(id: number, nome: string) {
    this.nome = nome
    this.id = id
  }
}

export class SemestreModel {
  id: number = 0;
  nome: string = "";

  constructor(id: number, nome: string) {
    this.nome = nome
    this.id = id
  }
}

export class ContratoHomologacaoModel {
  contractCode: number = 0;
  customer: string = "";

  constructor(contractCode: number, customer: string) {
    this.customer = customer
    this.contractCode = contractCode
  }
}

export class LogoffModel {
  login: string = "";
  usuario: string = "";

  constructor(login: string, usuario: string) {
    this.login = login
    this.usuario = usuario
  }
}
